module["exports"] = [
  "#####",
  "#####-####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/address/postcode.js
// module id = 902
// module chunks = 0